module.exports = __webpack_public_path__ + "static/media/song5.1550d021.mp3";